module.exports = __webpack_public_path__ + "img/MG.dc320f93.svg";